import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FlexRow, SvgIcon } from '@make-software/tg-mini-app-ui';

import { openLink } from '@/utils';
import { ACTIVITY_PATH } from '@/app/paths';
import { HOW_VOTING_WORKS_URL } from '@/constants';
import { PageWrapper, SecondaryText, TitleRow, CommonDescription, Round2ActivityCard, LoadingState, ErrorState, NotFoundState } from '@/shared';
import InfoIcon from '@/shared/assets/icons/ic-info.svg';

import { RoundContainer } from './styled';
import { ProjectHeader, RoundStats, VoteForm } from './components';
import { useScreen } from './useScreen';

export const HackathonProjectDetails: React.FC = () => {
  const navigate = useNavigate();
  const { documentId } = useParams();

  const {
    airdropInfo,
    project,
    loading,
    error,
    refetch,

    round,
    isRound2,
    canVote,

    rank,
    description,
    supporters
  } = useScreen(documentId);

  const navigateToActivity = React.useCallback(() => navigate(ACTIVITY_PATH), [navigate]);
  const openHowVotingWorks = React.useCallback(openLink(HOW_VOTING_WORKS_URL), []);

  if (loading) return <LoadingState />;
  if (error) return <ErrorState title="Failed to load project" />;
  if (!project) return <NotFoundState title="Project not found" />;

  return (
    <>
      <PageWrapper>
        <TitleRow
          weight={1}
          color="#FFFFFF"
          size="lg"
          margin="0 0 8px 0"
          fontWeight={700}
          fontFamily="Inter">
          CSPR.fans - The Agentic Buildathon
        </TitleRow>

        <ProjectHeader {...project} rank={rank} />

        {!!description && <CommonDescription>{description}</CommonDescription>}
      </PageWrapper>

      <RoundContainer>
        <FlexRow align="center" gap={10}>
          <TitleRow
            weight={1}
            color="#FFFFFF"
            size="lg"
            margin="0"
            fontWeight={700}
            fontFamily="Inter">
            Round {round}
          </TitleRow>

          <SvgIcon
            src={InfoIcon}
            size={24}
            color="#A9AAAD"
            style={{ cursor: 'pointer' }}
            onClick={openHowVotingWorks}
          />
        </FlexRow>

        <SecondaryText weight={3} size="md" color="#FFFFFF" margin="8px 0 0 0" fontFamily="Inter">
          Vote to select the winner projects
        </SecondaryText>

        <RoundStats
          supporters={supporters}
          rankPoints={isRound2 ? (project?.round2_balance ?? 0) : (project?.round1_balance ?? 0)}
          supportRankText={`#${rank ?? 0} in the support rank`}
          onClick={navigateToActivity}
          isSecondRound={isRound2}
        />

        {canVote && (
          <>
            <TitleRow
              weight={1}
              color="#FFFFFF"
              size="lg"
              margin="0 0 8px 0"
              fontWeight={700}
              fontFamily="Inter">
              Send your support to this project
            </TitleRow>

            <SecondaryText weight={3} size="md" color="#FFFFFF" fontFamily="Inter">
              Support this project sending FAN tokens to it
            </SecondaryText>

            <VoteForm projectAddress={project?.project_hash} refetchProjectDetails={refetch} />
          </>
        )}
        {!canVote && window.config.rounds === '2' && (
          <Round2ActivityCard startsAt={airdropInfo?.airdrop?.next_round_starts_on} withCountdown />
        )}
      </RoundContainer>
    </>
  );
};
